import axios from 'axios';
import { API_URL, getAuthHeader } from '.';
import { ResponseModel } from '../Models/ResponseModel';
import { Equipment } from '../Models/Equipment';
import { EquipmentTypeEnums } from '../Models/EquipmentTypeEnums';
import { EquipmentFeature } from '../Models/EquipmentFeature';
import { File } from '../Models/File';
import { Order } from '../Models/Order';
import { OrderItem } from '../Models/OrderItem';
import { SavedItem } from '../Models/SavedItem';
import { OrderCustom } from '../Models/OrderCustom';
import { OrderSearchRequest } from '../Models/OrderSearchRequest';

class OrderApi {
  static getOrder(id: number) {
    return axios.get<Order>(`${API_URL}/api/order/${id}`, getAuthHeader());
  }
  static getOrderList() {
    return axios.get<Order[]>(`${API_URL}/api/order/list`, getAuthHeader());
  }
  static getOrderListCustom(request: OrderSearchRequest) {
    return axios.post<OrderCustom[]>(
      `${API_URL}/api/order/list/custom`,
      request,
      getAuthHeader()
    );
  }
  static getOrderItemsCount(orderId: number) {
    return axios.get<number>(
      `${API_URL}/api/order/itemscount/${orderId}`,
      getAuthHeader()
    );
  }
  static checkUserOpenOrder(userId: number) {
    return axios.get<Order>(
      `${API_URL}/api/order/user/${userId}`,
      getAuthHeader()
    );
  }
  static getUserOrders(userId: number) {
    return axios.get<Order[]>(
      `${API_URL}/api/order/user/list/${userId}`,
      getAuthHeader()
    );
  }
  static getSavedItems(userId: number) {
    return axios.get<SavedItem[]>(
      `${API_URL}/api/order/saved/${userId}`,
      getAuthHeader()
    );
  }
  static saveItem(request: Equipment) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/order/saveditem`,
      request,
      getAuthHeader()
    );
  }
  static deleteSavedItem(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/order/saveditem/delete/${id}`,
      getAuthHeader()
    );
  }
  static moveSavedItemToCart(request: SavedItem, orderId: number) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/order/saveditem/move/${orderId}`,
      request,
      getAuthHeader()
    );
  }
  static addUpdateOrder(request: Order) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/order`,
      request,
      getAuthHeader()
    );
  }
  static addUpdateOrderItem(request: OrderItem) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/order/orderitem`,
      request,
      getAuthHeader()
    );
  }
  static updateOrderItemQuantity(request: OrderItem) {
    return axios.post<ResponseModel>(
      `${API_URL}/api/order/orderitem/updatequantity`,
      request,
      getAuthHeader()
    );
  }
  static deleteOrderItem(id: number) {
    return axios.delete<ResponseModel>(
      `${API_URL}/api/order/orderitem/delete/${id}`,
      getAuthHeader()
    );
  }
  static sendToRimss(orderId: number) {
    return axios.post<boolean>(
      `${API_URL}/api/order/rimss/send/${orderId}`,
      null,
      getAuthHeader()
    );
  }
}

export default OrderApi;
